import { List } from "immutable";
import { MobileBaseObject } from "./mobile-base-object";

export interface IMessage extends MobileBaseObject {
  type: string;
  senderName: string;
  senderUserId: string;
  recipientID: string;
  recipientName: string;
  title: string;
  body: string;
  receipt: boolean;
  dueDate: Date;
  airportID: string;
  isRead: boolean;
  response: string;
  meta: string;
}


export class Message extends MobileBaseObject implements IMessage {

  public type: string;
  public senderName: string;
  public senderUserId: string;
  public recipientID: string;
  public recipientName: string;
  public title: string;
  public body: string;
  public receipt: boolean;
  public dueDate: Date;
  public airportID: string;
  public isRead: boolean;
  public response: string;
  public meta: string;


  public constructor(
    message: Partial<IMessage>
  ) {
    super();

    this.type = message.type;
    this.senderName = message.senderName;
    this.senderUserId = message.senderUserId;
    this.recipientID = message.recipientID;
    this.recipientName = message.recipientName;
    this.title = message.title;
    this.body = message.body;
    this.receipt = message.receipt;
    this.dueDate = message.dueDate;
    this.airportID = message.airportID;
    this.isRead = message.isRead;
    this.response = message.response;
    this.meta = message.meta;

    this.id = message.id;
    this.createdAt = message.createdAt;
    this.updatedAt = message.updatedAt;
  }

  public static ToTypeSafe(message: Message): Message {
    let typeSafeMessage = new Message(message);
    typeSafeMessage.type = message.type;
    typeSafeMessage.senderName = message.senderName;
    typeSafeMessage.senderUserId = message.senderUserId;
    typeSafeMessage.recipientID = message.recipientID;
    typeSafeMessage.recipientName = message.recipientName;
    typeSafeMessage.title = message.title;
    typeSafeMessage.body = message.body;
    typeSafeMessage.receipt = message.receipt;
    typeSafeMessage.dueDate = new Date(message.dueDate);
    typeSafeMessage.airportID = message.airportID;
    typeSafeMessage.isRead = message.isRead;
    typeSafeMessage.response = message.response;
    typeSafeMessage.meta = message.meta;

    typeSafeMessage.id = message.id;
    typeSafeMessage.createdAt = new Date(message.createdAt);
    typeSafeMessage.updatedAt = new Date(message.updatedAt);

    return typeSafeMessage;
  }

  public static ToTypeSafeList(schedules: Message[]): Message[] {

    return schedules.map((s) => { return Message.ToTypeSafe(s); });

  }

}


